import { FormFieldTypes } from "../../../../../components/finalForms/libs/data/formFieldType";
import { validationTypes } from "../../../../../components/finalForms/libs/data/ValidationTypes";
import { GridColumnType } from "../../../../../components/FinalMolGrid/libs/data/gridColumnType";

const initState = {
    environmentName: "",
};

export const ProjectEnvironmentFormData = {
  name: "Environment Name Form",
  initialState: initState,
  section: [
    {
      sectionId: "projectVersion",
      title: "Project Version",
      row: {},
      style: {
        sectionStyle: "col-lg-12 col-md-12",
      },
      wrapperTemplate: <div className="form-card row"></div>,
      fields: [
        {
          id: "environmentName",
          label: "Environment Name",
          Field_Name: "Environment Name",
          fieldType: FormFieldTypes.INPUT,
          dataField: "environmentName",
          fieldSetting: {
            placeholder: "Please Enter Environment Name",
            allowSpace: true,
            isDisable: false,
            maxLength: 50,
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-12 col-md-12 mb-1 validation-left-0",
          },
        },
       
      ],
    },
  ],
};

export const ProjectEnvironmentGridConfig = {
  columns: [
    {
      name: "Environment Name",
      fieldName: "environmentName",
      allowShort: false,
      colStyle: {
        width: "75%",
        textAlign: "center",
      },
    },
    
    {
      name: "Action",
      colType: GridColumnType.ACTION,
      colStyle: {
        width: "25%",
        textAlign: "center",
      },
      defaultAction: {
        allowEdit: true,
        allowDelete: true,
      },
    },
  ],
};
export default ProjectEnvironmentFormData;
